/**
 * Pure word-count rules for the Espace Pro event/exhibition description fields.
 *
 * The description inputs advertise a 250-word limit (`wordLimit`), but the
 * limit is only enforced while typing — a paste can exceed it, and nothing
 * blocked submission. This module is the shared, unit-tested source of truth
 * used by the description step's validation so an over-limit description can no
 * longer slip past "Suivant".
 */

export const DESCRIPTION_WORD_LIMIT = 250

export function countWords(text?: string | null): number {
  if (!text) return 0
  const trimmed = text.trim()
  if (!trimmed) return 0
  return trimmed.split(/\s+/).length
}

export function exceedsWordLimit(
  text?: string | null,
  limit: number = DESCRIPTION_WORD_LIMIT
): boolean {
  return countWords(text) > limit
}
